import { LocaleManager } from "@domain/localization/locale-manager";
import { User } from "@domain/user/user";
import { UserManager } from "@domain/user/user-manager";
import { isNotNil } from "@utils/assert";
import { dateToDateDto } from "@utils/date-utils";

import { AnalyticsCategory, AppAnalyticsService } from "@domain/analytics/analytics-types";
import { CustomDimensions } from "@domain/analytics/custom-dimensions";

const HARDCODED_USER_STATUS = "physio";

export class AnalyticsDimensionsManager {
	constructor(
		private readonly analyticsService: AppAnalyticsService,
		private readonly userManager: UserManager,
		private readonly localeManager: LocaleManager,
	) {
		userManager.user.subscribe(user => {
				this.updateAnalyticsId(user);
				this.computeCustomDimensions();
		});
		userManager.onUserFirstConnection.addOnce(() => {
			this.analyticsService.trackEvent({
				category: AnalyticsCategory.REGISTRATION,
				action: "physioOnboarding",
			});
		});
	}

	private updateAnalyticsId(user: User | null) {
		if (isNotNil(user)) {
			this.analyticsService.setUserId(user.analyticsId);
			return;
		}
		this.analyticsService.setUserId(null);
	}

	computeCustomDimensions(): void {
		const user = this.userManager.user.get();
		this.analyticsService.setCustomDimension(
			CustomDimensions.registrationDate,
			user ? dateToDateDto(user.creationDate) : null,
		);

		this.analyticsService.setCustomDimension(CustomDimensions.userCountry, user?.country.toLowerCase() ?? null);
		this.analyticsService.setCustomDimension(CustomDimensions.envStatus, process.env.ENVIRONMENT ?? null);
		this.analyticsService.setCustomDimension(CustomDimensions.userEnv, HARDCODED_USER_STATUS);
		this.analyticsService.setCustomDimension(
			CustomDimensions.platformLanguage,
			this.localeManager.locale.get().toLowerCase(),
		);
		this.analyticsService.setCustomDimension(
			CustomDimensions.deviceLanguage,
			this.localeManager.getNavigatorLocale().toLowerCase(),
		);

		this.analyticsService.setCustomDimension(CustomDimensions.loginStatus, isNotNil(user) ? "logged" : "anonymous");

		if (isNotNil(user)) {
			this.analyticsService.setCustomDimension(CustomDimensions.isTester, user.isTester.toString());
			this.analyticsService.setCustomDimension(CustomDimensions.isReviewer, user.isReviewer.toString());
		}
	}
}
